export default {
  cookiecontent: `我们在网站及其他在线服务上使用 Cookie，以确保其正确运作，并确保您能充分利用我们的网站。我们亦使用 Cookie
				来分析使用者如何使用及互动我们的网站，并启用社交媒体功能。您可以选择接受或拒绝这些 Cookie，或自定义您允许的 Cookie
				类型。请注意，若您拒绝某些 Cookie，可能会无法完全使用网站的功能。
				<a href="/cookie" target="_blank">《Cookie政策》</a>。`,
  同意: "同意",
  拒绝: "拒绝",
  Cookie政策: "Cookie政策",
  本Cookie政策说明EBCFinancial: `本 Cookie 政策说明 EBC Financial
          Group（以下称「EBC」、「我们」或「本公司」）如何在我们的网站
          www.ebc.com（以下称「本网站」）上使用 Cookie 与类似技术。`,
  什么是Cookie: "1. 什么是 Cookie？",
  Cookie是当您浏览EBC: `Cookie 是当您浏览 EBC
          网站时储存在您装置（如计算机或手机）上的小型文本文件。这些档案普遍用来提高网站效能，并向网站拥有者提供信息。`,
  您可透过以下网站了解更多: "您可透过以下网站了解更多 Cookie 信息：",
  我们使用的Cookie类型: "2. 我们使用的 Cookie 类型",
  tabletop: "",
  Cookie类型: "Cookie类型",
  说明: "说明",
  必要Cookie: "必要 Cookie",
  此类Cookie是网站正常运作所必需: `此类 Cookie
              是网站正常运作所必需，无法被关闭。它们通常在您进行如填写窗体或设定隐私偏好等操作时被设置。您可透过浏览器封锁这些
              Cookie，但网站某些功能将无法使用。`,
  效能分析Cookie: "效能（分析）Cookie",
  此类Cookie协助我们计算访客数与流量来源: `此类 Cookie
              协助我们计算访客数与流量来源，以改善网站效能与内容。我们能藉此了解哪些页面受欢迎，使用者如何浏览网站等。`,
  功能性Cookie: "功能性 Cookie",
  使网站能提供更进阶的功能与个人化体验: `使网站能提供更进阶的功能与个人化体验。这些 Cookie
              可能由我们设置，也可能由我们引入的第三方服务提供。若不允许这些
              Cookie，部分服务可能无法正常使用。`,
  tablebottom: "",
  如何管理Cookie: "3. 如何管理 Cookie",
  您有权决定是否接受Cookie:
    "您有权决定是否接受 Cookie。大多数浏览器提供以下功能：",
  查看装置上已安装的Cookie: "查看装置上已安装的 Cookie",
  删除Cookie: "删除 Cookie",
  封锁Cookie: "封锁 Cookie",
  设定特定网站的Cookie偏好: "设定特定网站的 Cookie 偏好",
  详细操作请参阅您的浏览器说明页:
    "详细操作请参阅您的浏览器说明页，或使用以下链接：",
  同意h2: "4. 同意",
  当您使用本网站: `当您使用本网站，即表示您同意我们在您的装置上设置上述类型的
          Cookie（除非您在浏览器中封锁），并依本政策使用相关数据。`,
  政策更新: "5. 政策更新",
  本Cookie政策可能因应实务或法律改变而更新: `本 Cookie
          政策可能因应实务或法律改变而更新。如有重大更动，我们将在网站上发布公告通知您。<br />
          如您对本政策或我们使用 Cookie 有任何疑问，请联络：<a class="a-normal" href="mailto:cs@ebc.com">cs@ebc.com</a>`,
  最后更新时间: "最后更新时间：2025年5月",
};
